import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { pathMatchesRoute } from "@faire/web--source/common/routes/RouteMatcher";
import { route as notificationsPage } from "@faire/web-api--source/routes/user/notifications";
export var useIsOnNotificationsPage = function() {
    var pathname = useZustandLocation(function(state) {
        return state.pathname;
    }).pathname;
    return pathMatchesRoute(pathname, notificationsPage);
};
